import { render } from "./EditActivities.vue?vue&type=template&id=696877bd"
import script from "./EditActivities.vue?vue&type=script&lang=js"
export * from "./EditActivities.vue?vue&type=script&lang=js"

import "./EditActivities.vue?vue&type=style&index=0&id=696877bd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__